/// <amd-module name="Environments/EnvironmentDetails/Actions/EnvironmentDeploymentsHistoryActions" />
import { TaskOrchestrationOwner } from "DistributedTask/Client/Contracts/TaskAgent";
import { IEnvironmentDeploymentHistoryResult } from "Environments/Client/EnvironmentContracts";
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";

export class EnvironmentDeploymentsHistoryActions extends ActionsHubBase {

    public static getKey(): string {
        return "environment-deployments-actions";
    }

    public initialize(instanceId?: string) {
        this._updateExecutionRecords = new Action<IEnvironmentDeploymentHistoryResult>();
        this._appendExecutionRecords = new Action<IEnvironmentDeploymentHistoryResult>();
        this._updatePipelineDefinitions = new Action<TaskOrchestrationOwner[]>();
    }

    public get updateExecutionRecords(): Action<IEnvironmentDeploymentHistoryResult> {
        return this._updateExecutionRecords;
    }

    public get appendExecutionRecords(): Action<IEnvironmentDeploymentHistoryResult> {
        return this._appendExecutionRecords;
    }

    public get updatePipelineDefinitions(): Action<TaskOrchestrationOwner[]> {
        return this._updatePipelineDefinitions;
    }

    private _updateExecutionRecords: Action<IEnvironmentDeploymentHistoryResult>;
    private _appendExecutionRecords: Action<IEnvironmentDeploymentHistoryResult>;
    private _updatePipelineDefinitions: Action<TaskOrchestrationOwner[]>;
}
